'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Carousel = function Carousel(_ref) {
  var images = _ref.images,
      maxHeight = _ref.maxHeight,
      _ref$altText = _ref.altText,
      altText = _ref$altText === undefined ? 'Screenshot' : _ref$altText;

  var maxHeightValue = maxHeight ? maxHeight + 'px' : '450px';
  return _react2.default.createElement(
    'div',
    { className: 'carousel-container-outer', style: { maxWidth: '100%', overflowX: 'hidden' } },
    _react2.default.createElement(
      'div',
      {
        className: 'carousel-container-inner',
        style: {
          maxHeight: maxHeightValue,
          overflowX: 'scroll',
          overflowY: 'hidden',
          whiteSpace: 'nowrap'
        }
      },
      images && images.map(function (el, i) {
        return !!el && _react2.default.createElement(
          'div',
          { className: 'carousel-image-container', key: i, style: { display: 'inline-block', verticalAlign: 'bottom' } },
          _react2.default.createElement('img', {
            alt: altText + ' - ' + i,
            className: 'carousel-image',
            src: el,
            style: { maxHeight: maxHeightValue }
          })
        );
      })
    )
  );
};

Carousel.propTypes = {
  altText: _propTypes2.default.string,
  images: _propTypes2.default.arrayOf(_propTypes2.default.string),
  maxHeight: _propTypes2.default.string
};

exports.default = Carousel;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/Carousel.js
// module id = 579
// module chunks = 0